import { debounce } from "@sazka/utils/debounce";
import Flickity from "flickity";

$(() => {
    if (!$(".lp-steps-cards").length) {
        return;
    }
    let flickities = [];

    const resizeHandler = debounce(function () {
        serviceFlickity();
    }, 50);

    $(window).on("resize", resizeHandler);

    function initFlickity() {
        $(".lp-steps-cards .lp-steps-cards__container").each((_, elem) => {
            flickities.push(
                new Flickity(elem, {
                    autoPlay: false,
                    pageDots: false,
                    draggable: true,
                    prevNextButtons: true,
                    wrapAround: false,
                    percentPosition: true,
                    cellAlign: "left",
                })
            );
        });
    }

    function serviceFlickity() {
        if (window.matchMedia("(max-width: 897px)").matches) {
            if (!flickities.length) {
                initFlickity();
            } else {
                flickities.forEach((flickity) => {
                    if (!flickity.isActive) {
                        flickity._create();
                    }
                });
            }
            if ($(".lp-steps-cards .lp-steps-cards__image").length) {
                flickities.forEach((flickity) => {
                    flickity.resize();
                });
                $(".lp-steps-cards .lp-steps-cards__image").css({
                    left:
                        $(".lp-steps-cards .lp-step-card.is-selected").offset().left -
                        $(".lp-steps-cards .lp-steps-cards__wrapper").offset().left,
                });
            }
        } else if (window.matchMedia("(min-width: 897px)").matches && flickities.length) {
            try {
                flickities.forEach((flickity) => {
                    flickity.destroy();
                });
                flickities = [];
            } catch {}
        }
    }
});
